import { Action, Reducer } from "redux"
import { IconName } from "../../core/types/icon-names"
import { Display, NotificationType } from "../../core/types/types"

export interface DialogState {
  label: string
  type: HTMLSdxDialogElement["type"]
  iconName?: IconName
  iconColorClass: string
  display: Display
  toggle: () => Promise<void>
  contentEl?: HTMLSdxDialogContentElement
  toggleEl?: HTMLSdxDialogToggleElement
  notificationType?: NotificationType | "gradient"
  isUserInteractionInProgress: boolean
  alignHeaderCenter: boolean
}

export type DialogActions = Action<string>

export const dialogReducer: Reducer<DialogState, DialogActions> = (
  state = {} as DialogState,
  action,
): DialogState => {
  switch (action.type) {
    default:
      return state
  }
}

export function getInitialState(): DialogState {
  return {
    label: "",
    type: "modal",
    iconColorClass: "",
    display: "closed",
    toggle: () => Promise.resolve(),
    contentEl: undefined,
    toggleEl: undefined,
    notificationType: undefined,
    isUserInteractionInProgress: false,
    alignHeaderCenter: false,
  }
}
